import { UserNotifiedDocument } from '@gql'
import { useSubscription } from '@hooks/graphql'
import useNotifier from '@hooks/useNotifier'

export function useUserNotifications(disabled: boolean) {
  const notify = useNotifier()

  useSubscription(UserNotifiedDocument, {
    onData: (data) => {
      const userData = data.data.data
      if (!userData) {
        return
      }

      notify({
        status:
          userData.userNotified.type === 'SUCCESS'
            ? 'success'
            : userData.userNotified.type === 'ERROR'
              ? 'error'
              : userData.userNotified.type === 'WARNING'
                ? 'warning'
                : 'info',
        text: userData.userNotified.text,
      })
    },
    skip: disabled,
    variables: {
      ignoreSameSession: false,
    },
  })
}
